import classnames from 'classnames';

import { cn } from 'utils';

interface Props {
  menuList: string[];
  selectedMenuIndex: number;
  onClickTab: (index: number) => void;
  icons?: React.ReactNode[];
}

// ! 기존 MenuTab 변경 없이 아이콘 사용하려고 만든 임시 컴포넌트 (250807추가)

const MenuTabSecond = ({ menuList, selectedMenuIndex, onClickTab, icons }: Props) => {
  return (
    <div className="w-full">
      <div className={cn('flex w-full flex-row gap-2', 'md:px-6')}>
        {menuList.map((menu, index) => (
          <button
            key={`${menu}-${index}`}
            className={cn('flex w-32 flex-col items-center justify-center py-2 pb-2.5', 'md:px-4', {
              'border-b-2 border-button-bg_primary pb-2': index === selectedMenuIndex
            })}
            onClick={() => onClickTab(index)}
          >
            {icons && icons[index] && (
              <div className={classnames('mb-2', {
                'opacity-100': index === selectedMenuIndex,
                'opacity-40': index !== selectedMenuIndex
              })}>
                {icons[index]}
              </div>
            )}
            <span
              className={classnames(
                'text-nowrap text-body2 font-medium',
                {
                  'text-text-primary': index === selectedMenuIndex
                },
                {
                  'text-text-tertiary': index !== selectedMenuIndex
                }
              )}
            >
              {menu}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MenuTabSecond;
